const CONST = {

    ENV: process.env.NODE_ENV,

    DEBUG: process.env.NODE_ENV !== 'production',

    FORCE_ASYNC_DELAY: 1000

};

export default CONST;
